var React = require('react');

function LsIconInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12.5","r":"12","fill":"#F1C950","key":0}),React.createElement("path",{"d":"M14.4949 4.96019H10.725L6.95508 18.8717H15.2914L16.194 15.6328H11.5745L14.4949 4.96019Z","fill":"#242A40","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 3.36364C6.95413 3.36364 2.86364 7.45413 2.86364 12.5C2.86364 17.5459 6.95413 21.6364 12 21.6364C17.0459 21.6364 21.1364 17.5459 21.1364 12.5C21.1364 7.45413 17.0459 3.36364 12 3.36364ZM1.5 12.5C1.5 6.70101 6.20101 2 12 2C17.799 2 22.5 6.70101 22.5 12.5C22.5 18.299 17.799 23 12 23C6.20101 23 1.5 18.299 1.5 12.5Z","fill":"#242A40","key":2})]);
}

LsIconInline.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = LsIconInline;

LsIconInline.default = LsIconInline;
